// extracted by mini-css-extract-plugin
export default {"button":"brand-button_button__0uKcF","label":"brand-button_label__fZYxE","spinner":"brand-button_spinner__-K8N-","spin":"brand-button_spin__wXBX-"};